/**
 * Работа с урлами
 * @packageDocumentation
 */

import punycode from 'punycode';

/**
 * Раскодировать все не ASCII символы в домене URL
 * @param url - домен в ASCII формате
 * @return домен в Unicode формате
 */
export const fromPuny = (url: string = ''): string => {
	url = url.replace(/[\r\n]/g, ' ').trim();

	if (url.indexOf('xn--') === -1) return url;
	if (url.indexOf('/') === -1) return punycode.toUnicode(url);

	const host = getHost(url);

	let hostNormal = host.toLowerCase();
	hostNormal = punycode.toUnicode(hostNormal);

	if (host !== hostNormal) url = url.replace(host, hostNormal);

	return url;
};

/**
 * Закодировать все не ASCII символы в домене URL
 * @param url - домен в Unicode формате
 * @return домен в ASCII формате
 */
export const toPuny = (url: string): string => {
	url = url.replace(/[\r\n]/g, ' ').trim();

	if (url.indexOf('/') === -1) return punycode.toASCII(url);

	const host = getHost(url);

	let hostNormal = host.toLowerCase();
	hostNormal = punycode.toASCII(hostNormal);

	if (host !== hostNormal) url = url.replace(host, hostNormal);

	return url;
};

/**
 * Получить имя хоста из URL
 */
export const getHost = (url: string): string => {
	return url.replace(/(?:^\w+:\/\/)?([^:/]+).*/i, '$1');
};

/**
 * Привести url к стандартному виду (не в пуникоде и хост в нижнем регистре)
 */
export const normalize = (url: string): string => {
	url = fromPuny(url);
	url = hostToLowerCase(url);

	return url;
};

/**
 * Перевести в url имя хоста в нижний регистр
 */
export const hostToLowerCase = (url: string): string => {
	const host = getHost(url);
	const hostNormal = host.toLowerCase();
	if (host !== hostNormal) url = url.replace(host, hostNormal);

	return url;
};

/**
 * Получить закодированную строку
 */
export const encode = (string: string): string => { return escape(utf8Encode(string)); };

/**
 * Раскодировать строку, полученную функцией encode
 */
export const decode = (string: string): string => { return utf8Decode(unescape(string)); };

const utf8Encode = (string: string): string => {
	string = string.replace(/\r\n/g, '\n');
	let utftext = '';

	for (let n = 0; n < string.length; n++) {
		const c = string.charCodeAt(n);

		if (c < 128) {
			utftext += String.fromCharCode(c);
		} else if ((c > 127) && (c < 2048)) {
			utftext += String.fromCharCode((c >> 6) | 192);
			utftext += String.fromCharCode((c & 63) | 128);
		} else {
			utftext += String.fromCharCode((c >> 12) | 224);
			utftext += String.fromCharCode(((c >> 6) & 63) | 128);
			utftext += String.fromCharCode((c & 63) | 128);
		}
	}

	return utftext;
};

/**
 * private method for UTF-8 decoding
 */
const utf8Decode = (utftext: string): string => {
	let string = '';
	let i = 0;
	let c = 0,
		c1 = 0,
		c2 = 0;

	while (i < utftext.length) {
		c = utftext.charCodeAt(i);

		if (c < 128) {
			string += String.fromCharCode(c);
			i++;
		} else if ((c > 191) && (c < 224)) {
			c2 = utftext.charCodeAt(i + 1);
			string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
			i += 2;
		} else {
			c2 = utftext.charCodeAt(i + 1);
			let c3 = utftext.charCodeAt(i + 2);
			string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
			i += 3;
		}
	}

	return string;
};
